"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "tito": {
    "a2b32e96": [{
      "hkey": "dd940732",
      "slug": "tito",
      "name": "Tito",
      "primary": true,
      "skipSearch": false
    }],
    "campi": [{
      "hkey": "dd940732",
      "slug": "tito",
      "name": "Tito",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5efc351d": [{
      "hkey": "dd940732",
      "slug": "tito",
      "name": "Tito",
      "primary": true,
      "skipSearch": false
    }],
    "fraschete": [{
      "hkey": "dd940732",
      "slug": "tito",
      "name": "Tito",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a4fb7831": [{
      "hkey": "dd940732",
      "slug": "tito",
      "name": "Tito",
      "primary": true,
      "skipSearch": false
    }],
    "isola-di-sant-angelo-le-fratte": [{
      "hkey": "dd940732",
      "slug": "tito",
      "name": "Tito",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a225840c": [{
      "hkey": "dd940732",
      "slug": "tito",
      "name": "Tito",
      "primary": true,
      "skipSearch": false
    }],
    "radolena": [{
      "hkey": "dd940732",
      "slug": "tito",
      "name": "Tito",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ad102c3a": [{
      "hkey": "dd940732",
      "slug": "tito",
      "name": "Tito",
      "primary": true,
      "skipSearch": false
    }],
    "rammotta": [{
      "hkey": "dd940732",
      "slug": "tito",
      "name": "Tito",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;